/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { OrderAttentionItem } from './OrderAttentionItem';
// @ts-ignore
import {
// @ts-ignore
    OrderAttentionItemFromJSON,
// @ts-ignore
    OrderAttentionItemFromJSONTyped,
// @ts-ignore
    OrderAttentionItemToJSON,
} from './OrderAttentionItem';

/**
 * 
 * @export
 * @interface OrderAttentionListResponse
 */
export interface OrderAttentionListResponse {
    /**
     * 
     * @type {number}
     * @memberof OrderAttentionListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderAttentionListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<OrderAttentionItem>}
     * @memberof OrderAttentionListResponse
     */
    items: Array<OrderAttentionItem>;
}

/**
 * Check if a given object implements the OrderAttentionListResponse interface.
 */
// @ts-ignore
export function instanceOfOrderAttentionListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function OrderAttentionListResponseFromJSON(json: any): OrderAttentionListResponse {
    return OrderAttentionListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderAttentionListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderAttentionListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(OrderAttentionItemFromJSON)),
    };
}

// @ts-ignore
export function OrderAttentionListResponseToJSON(value?: OrderAttentionListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(OrderAttentionItemToJSON)),
    };
}

